module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'm-card': !_vm.isInCard, 'm-card-incard': _vm.isInCard, 'm-card--elite': _vm.data.ShowStatus === 1, fz15: true
    }
  }, [_c('div', {
    staticClass: "m-card-header"
  }, [_c('a', {
    attrs: {
      "href": _vm.data.UserHomeUrl
    }
  }, [(!_vm.isInCard) ? _c('div', {
    staticClass: "m-avatar"
  }, [_c('img', {
    attrs: {
      "src": _vm.data.UserHeadUrl
    }
  })]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "fz15 m-avatar--name"
  }, [_vm._v("\n        " + _vm._s(_vm.data.UserName) + "\n      ")])]), _vm._v(" "), (_vm.isHost) ? _c('span', {
    staticClass: "fz11 m-avatar-name--host"
  }, [_vm._v("主持人")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "m-card-body"
  }, [(_vm.data.PostTitle) ? _c('h4', [_vm._v(_vm._s(_vm.data.PostTitle))]) : _vm._e(), _vm._v(" "), (_vm.filteredContentLength > 100 && _vm.openAllShow) ? _c('div', [_c('span', {
    staticClass: "fz16",
    domProps: {
      "innerHTML": _vm._s(_vm.filteredContent.substring(0, 100))
    }
  }), _vm._v("\n      ..."), _c('a', {
    staticClass: "c-blue",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.openAll
    }
  }, [_vm._v("全文")])]) : _c('div', [_c('span', {
    staticClass: "fz15",
    domProps: {
      "innerHTML": _vm._s(_vm.filteredContent)
    }
  }), _vm._v(" "), (_vm.filteredContentLength > 100 && !_vm.openAllShow) ? _c('a', {
    staticClass: "c-blue",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.closeAll
    }
  }, [_vm._v("收起")]) : _vm._e()]), _vm._v(" "), (_vm.imgLists.length > 0 && !_vm.videoSrc) ? _c('sq-card-images', {
    attrs: {
      "imgs": _vm.imgLists
    }
  }) : _vm._e(), _vm._v(" "), (_vm.videoSrc) ? _c('sq-card-video', {
    attrs: {
      "src": _vm.videoSrc
    }
  }) : _vm._e()], 1), _vm._v(" "), _vm._t("default"), _vm._v(" "), _c('div', {
    staticClass: "m-card-footer"
  }, [(_vm.data.IsPost) ? _c('a', {
    staticClass: "fz13 m-card-actions--post",
    attrs: {
      "href": _vm.postHref
    }
  }, [_vm._v("查看原帖")]) : _vm._e(), _vm._v(" "), (!_vm.data.IsPost) ? _c('a', {
    class: ['m-card-actions--favor', 'fz13', {
      'm-card-actions--favored': _vm.isFavored
    }],
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.handlePraise
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isFavored),
      expression: "!isFavored"
    }]
  }, [_vm._v("赞")]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.favoredCount && _vm.isFavored),
      expression: "favoredCount && isFavored"
    }]
  }, [_vm._v(_vm._s(_vm.favoredCount))])]) : _vm._e(), _vm._v(" "), (!_vm.data.IsPost) ? _c('a', {
    staticClass: "m-card-actions--reply fz13",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.reply
    }
  }, [_vm._v("回复")]) : _vm._e()])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-61e863f8"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/card/cardItem.vue
// module id = 207
// module chunks = 1